import '../styles/scss/theme.scss';
/* ------------------------------- */

console.log('ThemeJS loaded');

// Document Ready, most of your code should be put in here
$(function() {
    console.log('DOM is loaded');
});